/*
 * Copyright (c) 2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: enums.ts
 * Project: mle-client
 * Committed last: 2021/11/11 @ 1745
 * ---
 */

/**
 * Evita l'utilizzo di stringhe hard-coded per la gestione dei temi.
 * @enum
 */
export enum Themes {
  DARK = 'dark',
  LIGHT = 'light'
}

/**
 * Evita l'utilizzo di stringhe hard-coded per la gestione delle unità di misura.
 * @enum
 */
export enum MeasureUnits {
  MM = 'mm',
  PX = 'px',
  CM = 'cm',
  INCH = 'in',
}

/**
 * Evita l'utilizzo di stringhe hard-coded per la gestione dei profili colore.
 * @enum
 */
export enum ColorModes {
  COLORE = '0',
  BIANCO_NERO = '1'
}

/**
 * Evita l'utilizzo di stringhe hard-coded per la gestione dei gruppi di metadati in Mpes.
 * @enum
 */
export enum MetadataGroupKeys {
  TEXT_BASED = 'text-based',
  BOOLEANS = 'booleans',
}

/**
 * Evita l'utilizzo di stringhe hard-coded per la gestione delle chiavi di metadati in Mpes.
 * @enum
 */
export enum MetadataKeys {
  MEASURE_UNIT = 'measureUnit',
  USE_SMART_GUIDES = 'useSmartGuides',
}

/**
 * Evita l'utilizzo di stringhe hard-coded per la gestione dei sistemi operativi in uso.
 * @enum
 */
export enum OSs {
  MAC = 'MacOS',
  WINDOWS = 'Windows',
  LINUX = 'Linux',
}

/**
 * Evita l'utilizzo di stringhe hard-coded per la gestione dei tipi forma (di pamela e proprietari).
 * @enum
 */
export enum ShapeTypes {
  RECT = 'rect',
  CIRCLE = 'circle',
  ELLIPSE = 'ellipse',
  TRIANGLE = 'triangle',
  POLYGON = 'polygon',
  LINE = 'line',
  POLYLINE = 'polyline',
  RICH_TEXT = 'rich-text',
  TEXT = 'text',
  IMAGE = 'image',
  TABLE = 'table',
  BARCODE = 'barcode',
  WEDGE = 'wedge',
  EXPORT_VARIABLE = 'export-variable',
}

/**
 * Tutti gli shape types
 */
export const ALL_SHAPE_TYPES = Object.values(ShapeTypes) as ShapeTypes[];